const ServiceTypeEnum = {
  InPerson: 1,
  Phone: 2,
  Video: 3,
  OnlineWeb: 4,
  FaceToFaceIntercepts: 5,
  AuditsPricing: 6,
  CustomerSatisfaction: 7,
  EmployeeSurvey: 8,
  Other: 9,
  IVR: 10, // Disabled
  OnlineReputation: 11,
  BusinessIntelligence: 12,
  BareIfy: 13,
  // 'Setup' (14) has no type-specific fields — only the General section renders (base fallback).
  Setup: 14,
  // PricingAudits (15) is a distinct type that reuses the same form as AuditsPricing
  // (Audits - Price / QA, value 6); both coexist.
  PricingAudits: 15,
  InventoryAudits: 16,
};

export default ServiceTypeEnum;
